// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/base.scss
// module id = 6hTs
// module chunks = 53